import { Box } from '@chakra-ui/react';
import { useLocation } from 'react-router-dom';
import Header from './Header';

const Layout = ({ children }) => {
  const location = useLocation();
  const hideHeader = location.pathname.startsWith('/payments');

  return (
    <Box>
      {!hideHeader ? <Header /> : null}
      <Box as="main" pt={hideHeader ? 0 : '80px'}>
        {children}
      </Box>
    </Box>
  );
};

export default Layout;
